import styled from 'styled-components';

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  background: #ffffff;
  border-bottom: 1px solid #f0f0f0;
  position: sticky;
  top: 0;
  z-index: 10;
`;

export const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;

  button {
    min-width: 36px;
    height: 36px;
    border-radius: 50%;
    padding: 0;
    border-color: #e0e0e0;
  }
`;

export const BrandBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TitleText = styled.h1`
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
`;

export const SubtitleText = styled.div`
  font-size: 11px;
  color: #666666;
  margin: 0;
`;
